import { makeLMStyles } from '@launchmetrics/lm-ui';

export const useStyles = makeLMStyles(() => ({
	headerCellContentStyles: {
		display: 'flex',
		alignItems: 'center',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		width: '100%',
		marginTop: 'auto',
		marginRight: 'auto'
	},
	tableCellStyles: {
		variant: 'text.textSmBold',
		textTransform: 'capitalize',
		paddingX: 'spacing-8',
		paddingY: '14px',
		textAlign: 'left',
		borderBottomWidth: '1px',
		borderBottomStyle: 'solid',
		borderBottomColor: 'border.subtle'
	},
	tableCellSortedStyles: {
		paddingX: 'spacing-2',
		paddingY: 'spacing-8'
	}
}));
